import { useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import { useMemo } from 'react';
import { productInstancesAtomFamily, getProductInstancesKey } from '~/atoms/productInstances';
export const useProductInstances = (projectId, projectHandle) => {
    const productInstancesAtom = useMemo(() => productInstancesAtomFamily(getProductInstancesKey({ projectId, projectHandle })), [projectId, projectHandle]);
    const productInstancesLoadableAtom = useMemo(() => loadable(productInstancesAtom), [productInstancesAtom]);
    const loadableState = useAtomValue(productInstancesLoadableAtom);
    const error = loadableState.state === 'hasError'
        ? loadableState.error instanceof Error
            ? loadableState.error
            : new Error('Unknown error')
        : null;
    const data = loadableState.state === 'hasData' ? loadableState.data : [];
    const isLoading = loadableState.state === 'loading';
    return {
        data,
        isLoading,
        error
    };
};
